import Radio from '@jetbrains/ring-ui/components/radio/radio'
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip'
import React from 'react'

import {setError} from '../HttpsConfigurationPage.actions'
import httpsConfigurationApi from '../HttpsConfigurationPage.api'
import {CertificateInstallationTabs} from '../HttpsConfigurationPage.types'

import CertificateFetchForm from './CertificateFetchForm/CertificateFetchForm'
import CertificateUploadForm from './CertificateUploadForm/CertificateUploadForm'

import styles from './CertificateInstallationForm.css'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

function ErrorBlock() {
  const error = useAppSelector(state => state.https.error)

  return error != null ? <div className={styles.errorDescription}>{`${error.data}`}</div> : null
}

type CertificateInstallationFormProps = {
  defaultTab: CertificateInstallationTabs
  isMultiNodeSetup: boolean
}
function CertificateInstallationForm({
  defaultTab,
  isMultiNodeSetup,
}: CertificateInstallationFormProps) {
  const [tab, selectTab] = React.useState(defaultTab)

  const dispatch = useAppDispatch()
  const {data: pendingAcmeOrder} =
    httpsConfigurationApi.endpoints.getPendingAcmeOrder.useQueryState()
  const orderExists = pendingAcmeOrder != null

  const [_, {isLoading}] = httpsConfigurationApi.endpoints.fetchCertificateFromAcme.useMutation({
    fixedCacheKey: 'fetchCertificateFromAcme',
  })

  React.useEffect(() => {
    dispatch(setError(null))
  }, [tab, dispatch])

  const onChangeTab = React.useCallback((value: string) => {
    selectTab(value as CertificateInstallationTabs)
  }, [])

  return (
    <>
      <div className={styles.tabs}>
        <Radio className={styles.radioItem} value={tab} onChange={onChangeTab}>
          <Tooltip
            title={
              isMultiNodeSetup &&
              "Let's Encrypt certificates cannot be issued if TeamCity runs in a multinode setup"
            }
          >
            <Radio.Item value={CertificateInstallationTabs.FETCH} disabled={isMultiNodeSetup}>
              {"Fetch from Let's Encrypt"}
            </Radio.Item>
          </Tooltip>
          <Tooltip
            title={
              !isMultiNodeSetup &&
              orderExists &&
              "To manually upload a certificate, cancel the existing Let's Encrypt order"
            }
          >
            <Radio.Item
              value={CertificateInstallationTabs.UPLOAD}
              disabled={(!isMultiNodeSetup && orderExists) || isLoading}
            >
              {'Upload'}
            </Radio.Item>
          </Tooltip>
        </Radio>
      </div>
      {tab === CertificateInstallationTabs.UPLOAD && <CertificateUploadForm />}
      {tab === CertificateInstallationTabs.FETCH && <CertificateFetchForm />}
      <ErrorBlock />
    </>
  )
}

export default CertificateInstallationForm
